import React, { useState } from "react";
import "../css/Faqs.css";

const Faqs = () => {
  const [openFAQ, setOpenFAQ] = useState(null);

  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  const faqData = [
    {
      q: "How do I start training at ACE?",
      a: "Choose any plan, visit the gym with your confirmation email, and our team will set up your training profile instantly."
    },
    {
      q: "Do you offer personalized programs?",
      a: "Yes. Our Season and Elite memberships include personalized workout cycles and progress tracking."
    },
    {
      q: "Can I pause my membership?",
      a: "Members can freeze their account up to 2 times per year for a total of 60 days."
    },
    {
      q: "Are beginners welcome?",
      a: "Absolutely — ACE is built for every level. Our coaches adapt every session to your strength and comfort."
    },
    {
      q: "Do you provide nutrition guidance?",
      a: "Yes, Elite members receive full nutrition planning plus meal tracking through the ACE app."
    }
  ];

  return (
    <div className="faqs-page">

      {/* ================= HERO ================= */}
      <section className="faqs-hero">
        <h1>FAQS</h1>
        <p>Everything you need to know before starting your ACE journey.</p>
      </section>


      {/* ================= FAQ ACCORDION ================= */}
      <section className="faqs-container">
        
        <div className="faqs-left">
          <h2>Got Questions?</h2>
          <p>Here’s everything athletes ask before they join ACE.</p>
        </div>

        <div className="faqs-right">
          
          {faqData.map((item, index) => (
            <div 
              key={index} 
              className={`faq-item ${openFAQ === index ? "open" : ""}`}
              onClick={() => toggleFAQ(index)}
            >
              <div className="faq-question">
                <span>{item.q}</span>
                <span className="faq-icon">{openFAQ === index ? "—" : "+"}</span>
              </div>

              <div className="faq-answer">
                <p>{item.a}</p>
              </div>
            </div>
          ))}

        </div>

      </section>

    </div>
  );
};

export default Faqs;
